/**
 * DWT dependencies
 */

import { arrowRightIcon } from '../../img/icons';
import { getBlockPropAttr } from '../utils/block-utils';
import { filterOutWhiteSpace } from '../utils/general-utils';

/**
 * WP dependencies
 */

import { RichText, useBlockProps } from '@wordpress/block-editor';

const save = ({ attributes }) => {
  const {
    backgroundColor,
    text,
    textColor,
    width,
    alignment,
    textButtonOption,
    url,
    linkTarget,
    hasCTASlideFromCarousel,
    hasNewsletterParentBlock
  } = attributes;

  const blockProps = useBlockProps.save({
    className: 'block__button'
  });

  /**
   * Handle additional logic
   */

  const isFill = getBlockPropAttr( blockProps, 'className', 'is-style-fill' );
  const isOutline = getBlockPropAttr( blockProps, 'className', 'is-style-outline' );

  const isFillIsDefaultLogic = isFill || ( !isFill && !isOutline );

  const buttonTypeClass = ( !textButtonOption && isFillIsDefaultLogic )
    ? 'btn--primary'
    : ( !textButtonOption && !isFillIsDefaultLogic ) ? 'btn--secondary' : 'is-text-button';

  const noBackgroundClass = ( !textButtonOption && !backgroundColor ) ? 'no-background-color' : '';
  const noTextClass = ( !textButtonOption && !textColor ) ? 'no-text-color' : '';

  /**
   * Handle element styles
   */

  const bgColor = backgroundColor ? { backgroundColor } : undefined;
  const borderStyles = textColor ? { border: `1px solid ${textColor}` } : undefined;

  const buttonStyles = isFillIsDefaultLogic && !textButtonOption
    ? bgColor
    : !isFillIsDefaultLogic && !textButtonOption ? borderStyles : undefined;

  const textStyle = textColor ? { color: textColor } : undefined;

  /**
   * Handle element classes
   */

  const buttonWrapperClasses = filterOutWhiteSpace( [ `button-wrapper text-black flex gap-10 items-center w-${width}` ] );

  const buttonClasses = filterOutWhiteSpace( [
    buttonTypeClass,
    noBackgroundClass,
    noTextClass,
    `w-${width}`
  ] );

  const textLogic = hasNewsletterParentBlock ? 'Sign up' : text;
  const renderInBlock = !!( ( text || hasNewsletterParentBlock ) && !hasCTASlideFromCarousel );

  return (
    renderInBlock && (
      <div { ...blockProps }>
        <div className={ `button-alignment justify-${alignment}`}>

          <div className={ buttonWrapperClasses } style={ { ...textStyle } }>

            { textLogic && url && (
            // eslint-disable-next-line react/jsx-no-target-blank
              <a className={`flex items-center no-underline ${buttonClasses}` } style={ { ...buttonStyles, ...textStyle } } href={ url || null } target={ linkTarget ? '_blank' : null } rel={ linkTarget ? 'noopener' : null }>{ textLogic }</a>
            ) }

            { textLogic && !url && (
              <RichText.Content
                className={ buttonClasses }
                tagName='button'
                value={ textLogic }
                style={ { ...buttonStyles, ...textStyle } }
              />
            ) }

            { textButtonOption ? arrowRightIcon : undefined }

          </div>
        </div>
      </div>
    )
  );
};

export default save;
